<template>
    <div v-if="links" class="level-item__list level-item__list--active">
        <template v-for="link in links">
            <router-link
                :key="link.name"
                :to="link.route"
                class="basement-link bng-clickable bng-underlined"
                :class="{ crash: link.name === 'crash' && isJantaBets }"
                >{{ link.text | translate }}</router-link
            >
        </template>
    </div>
</template>

<script>
import Vue from 'vue';

import menuHelper from '../../../helpers/menu.helper';

export default {
    name: 'basement-categories',
    data() {
        return {
            links: null
        };
    },
    async mounted() {
        this.links = await menuHelper.getMenuLinks();
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        clientAlias() {
            return this.client && this.client.view && this.client.view.general && this.client.view.general.alias;
        },
        isJantaBets() {
            return this.clientAlias === 'Jantabets';
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/basement/categories.vue